export const FORM_TYPES = {
  TextForm: 'TextForm',
  PhotoUpload: 'PhotoUpload',
  Option: 'Option'
};